import React, { useState, useEffect } from 'react';
import './Apple.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';
import Practice from '../../../Unit3/Module15/Practice';
import { getVideo } from '../../../s3Func/s3Download';
import { DragDropContainer, DropTarget } from 'react-drag-drop-container';
import PracticeSituation from '../PracticeRecording.js'
import transitionSound  from './../glisten.mp3';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function ApplePractice(props) {
  // Initialize variables to be used later
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  // Device detection functions
  const isIPhone = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPhoneUserAgent = /iphone/.test(userAgent);
    const isSmallScreenTouch = window.innerWidth < 768 && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    
    return isIPhoneUserAgent || isSmallScreenTouch;
  };

  const isIPad = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPadUserAgent = /ipad/.test(userAgent) || (/macintosh/.test(userAgent) && 'ontouchend' in document);
    const isTabletScreenSize = window.innerWidth >= 768 && window.innerWidth <= 1024;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    return isIPadUserAgent || (isTabletScreenSize && isTouchDevice);
  };

  const isLaptop = () => {
    const isLargeScreen = window.innerWidth > 1024;
    const isDesktopSize = window.innerWidth >= 800 && !('ontouchstart' in window || navigator.maxTouchPoints > 0);
    
    return isLargeScreen || isDesktopSize;
  };

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [apples, setApples] = useState(false);
  const [apple1, setApple1] = useState(true);
  const [apple2, setApple2] = useState(false);
  const [apple3, setApple3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [practice, setPractice] = useState('');
  const [displayReview, setDisplayReview] = useState(false);
  const [openPractice, setOpenPractice] = useState(false);
  const [appleScene, setAppleScene] = useState(!props.day4);
  const [displayLearnVideo, setDisplayLearnVideo] = useState(!props.day4);
  const [learnVideo, setlearnVideo] = useState(props.video1);

  const [question, setQuestion] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);

  const [correctImg, setCorrectImg] = useState('');
  const [wrongImg1, setWrongImg1] = useState('');
  const [wrongImg2, setWrongImg2] = useState('');
  const [correctImgX, setCorrectImgX] = useState('');
  const [correctImgY, setCorrectImgY] = useState('');
  const [wrongImg1X, setWrongImg1X] = useState('');
  const [wrongImg1Y, setWrongImg1Y] = useState('');
  const [wrongImg2X, setWrongImg2X] = useState('');
  const [wrongImg2Y, setWrongImg2Y] = useState('');
  const [correctImgH, setCorrectImgH] = useState('');
  const [correctImgW, setCorrectImgW] = useState('');
  const [wrongImg1H, setWrongImg1H] = useState('');
  const [wrongImg1W, setWrongImg1W] = useState('');
  const [wrongImg2H, setWrongImg2H] = useState('');
  const [wrongImg2W, setWrongImg2W] = useState('');
  const [title, setTtitle] = useState('');
  const [changeText, setChangeText] = useState('');
  const [scene1, setScene1] = useState(null);
  const [scene2, setScene2] = useState(null);
  const [scene3, setScene3] = useState(null);
  const [seletedImg, setSeletedImg] = useState(null);
  const [seletedImgX, setSeletedImgX] = useState('');
  const [seletedImgY, setSeletedImgY] = useState('');
  const [animationEffect, setAnimationEffect] = useState('animationEffect');
  const [matchOptions, setMatchOptions] = useState(null);
  const [targetKey, setTargetKey] = useState('');
  const [endImg, setEndImg] = useState('');
  const [gameInfo1, setGameInfo1] = useState ('')
  const [gameInfo2, setGameInfo2] = useState ('')
  const [gameInfo3, setGameInfo3] = useState ('')
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const Tree = generateImageUrl('images/Module15Images/Tree.png');
  const apple1Img = generateImageUrl('images/Module20Images/U4_M5_Apple1.svg');
  const apple2Img = generateImageUrl('images/Module20Images/U4_M5_Apple2.svg');
  const apple3Img = generateImageUrl('images/Module20Images/U4_M5_Apple3.svg');
  const dog = generateImageUrl('images/Module20Images/practice/U4_M5_Practice_Dog.svg');
  const recycleBin = generateImageUrl('images/Module20Images/practice/U4_M5_RecycleBin.svg');
  const demoDaysBirdMessyHair = generateImageUrl('images/Module20Images/practice/U4_M5_Bird_MessyHair.svg');
  const demoDaysBirdNormal = generateImageUrl('images/Module20Images/practice/U4_M5_Bird.svg');
  const bird1GroceryBag = generateImageUrl('images/Module20Images/practice/1Bag_Bird.svg');
  const demoDaysBirdHappy = generateImageUrl('images/Module20Images/practice/happybird.svg');
  const bigBirdHappy = generateImageUrl('images/Module20Images/practice/U4_M5_Practice_HappyBird_Big.svg');
  const demoDaysDogWithOranges = generateImageUrl('images/Module20Images/practice/U4M5_DD2_Dog.svg');
  const demoDaysDog2GroceryBags = generateImageUrl('images/Module20Images/practice/twoBags_dog.svg');
  const demoDaysDog1GroceryBag = generateImageUrl('images/Module20Images/practice/1bag_dog.svg');
  const demoDaysRecycleBinWithBottle = generateImageUrl('images/newDesign/Unit4Module5/U4M5_DD_Spill.svg');
  const demoDaysWaterPuddle = generateImageUrl('images/newDesign/Unit4Module5/U4M5_DD_Spill_no_bottle.svg');
  const demoDaysSparkleMopWater = generateImageUrl('images/newDesign/Unit4Module5/U4M5_DD_no_Spill.svg');
  const BakeryStoreGreen = generateImageUrl('images/Module20Images/U4_M5_DailyReward_Bakery1@3x.png');
  const groceryStoreDogWithOranges = generateImageUrl('images/Module20Images/practice/U4M5_DD2_Dog-orange.svg');
  const groceryStoreDroppedBox = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_PurpleBox.svg');
  const groceryStoreCucumber = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Cucumber.svg');
  const groceryStoreBird = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_BasketAndBird.svg');
  const groceryStoreSquash = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Squash.svg');
  const groceryStoreBlueBoxes = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BlueBoxes.svg');
  const groceryStoreGroceriesInBasket = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BasketWithFood.svg');
  const groceryStoreDog2Bags = generateImageUrl('images/Module20Images/practice/twoBags_dog.svg');
  const groceryStoreDog1Bag = generateImageUrl('images/Module20Images/practice/U4M5_DD2_DogwithHeart.svg');
  const groceryStoreBoxOnShelfStandUp = generateImageUrl('images/Module20Images/practice/U4_M5_StandupBox_With_Sparkle.svg');
  const groceryStoreBirdWithListChecked = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BasketWithChecklist.svg');
  const hairSalonBirdHairMessy = generateImageUrl('images/Module20Images/practice/U4_M5_Bird_MessyHair.svg');
  const hairSalonWaterOverFlowPuddle = generateImageUrl('images/Module20Images/practice/U4_M5_SpillingSink.svg');
  const hairSalonComb = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Comb.svg');
  const hairSalonSprayBottle = generateImageUrl('images/Module20Images/practice/U4M5_Practice_spraybottle.svg');
  const hairSalonPlant = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Plant.svg');
  const hairSalonMirror = generateImageUrl('images/Module20Images/practice/U4M5_Practice_MirrorBig.svg');
  const hairSalonBird = generateImageUrl('images/Module20Images/practice/U4_M5_Bird.svg');
  const clothingStoreClothesGreenCrumpled = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_GreenClothesPile.svg');
  const clothingStoreClothesGreenFoldedOnShelf = generateImageUrl('images/Module20Images/practice/U4M5_GreenClothes_Folded.svg');
  const clothingStoreBird = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Bird_socks.svg');
  const clothingStoreSocks = generateImageUrl('images/Module20Images/practice/U4_M5_Bird_sock_1.svg');
  const clothingStoreLizardSad = generateImageUrl('images/Module20Images/practice/U4M5_Sad_Lizard_1.svg');
  const clothingStoreLizardHappy = generateImageUrl('images/Module20Images/practice/U4M5_Happy_Lizard.svg');
  const clothingStoreMonkey = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Cashier.svg');
  const clothingStoreClothesOrange = generateImageUrl('images/Module20Images/practice/U4M5_Practice_OrangeClothes.svg');
  const clothingStoreClothesPurple = generateImageUrl('images/Module20Images/practice/U4M5_Practice_PurpleClothes.svg');
  const lizardCandy = generateImageUrl('images/Module20Images/practice/U4M5_Happy_Lizard_candy.svg');

  const bakeryCrabBoxesWorried = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Crab_Box.svg');
  const bakeryBird = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Bird_Messyface.svg');
  const bakeryTrashCanCupcake = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_TrashCan_Big.svg');
  const bakeryLightSwitch = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Lightswitch.svg');
  const bakeryBreadRoll = generateImageUrl('images/newDesign/Unit4Module20/Bakery/assets/Unit4Module20BreadSmall.png');
  const bakeryBreadLoaf = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BreadLoaf.svg');
  const bakeryNapkinWithBird = generateImageUrl('images/Module20Images/practice/U4_M5_Bird_napkin.svg');
  const bakeryTrashCanMess = generateImageUrl('images/Module20Images/practice/trash_can_mess.svg');
  const bakeryCrabSmiling = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Crab_Boxes_happy.svg');
  const bakerySparkle = generateImageUrl('images/Module20Images/practice/U4M5_Practice_TrashCan_clean.svg');
  const movieLightSwitch = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Lightswitch.svg');
  const movieBird = generateImageUrl('images/Module20Images/practice/Bird_Lost .svg');
  const movieMonkeyHungry = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Hungry.svg');
  const moviePoster = generateImageUrl('images/newDesign/Unit4Module20/Cinema/assets/Unit4Module20Poster.png');
  const movieCrab = generateImageUrl('images/Module20Images/practice/U4M5_StaffCrab.svg');
  const movieRecycleBinWithBottle = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_RecycleandBottles_1.svg');
  const movieCrabPointing = generateImageUrl('images/Module20Images/practice/U4M5_Practice_CrabPointing.svg');
  const movie2WaterBottles = generateImageUrl('images/Module20Images/practice/U4M5_Practic_Recycleand2Bottle_1.svg');
  const movieMonkey = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Normal.svg');
  const movieMonkeyHappy = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Happy_popcorn.svg');
  const movieCrabThoughtHeart = generateImageUrl('images/Module20Images/practice/U4M5_StaffCrab_heart.svg');
  const movieRecycleBinSparkle = generateImageUrl('images/Module20Images/practice/U4_M5_RecycleBin_Clean_1.svg');
  const combHair = {
      img: generateImageUrl('images/Module20Images/practiceIcon/comb hair.png'),
      title: 'Comb your hair',
      audioPrompt: 'appfiles/caring/option_comb_your_hair.mp3',
  };
  const recycle = {
      img: generateImageUrl('images/Module20Images/practiceIcon/receycle bottle.png'),
      title: 'Recycle the bottle',
      audioPrompt: 'appfiles/caring/option_recycle_the_bottle.mp3',
  };
  const mop = {
      img: generateImageUrl('images/Module20Images/practiceIcon/mop.png'),
      title: 'Mop',
      audioPrompt: 'appfiles/caring/option_mop.mp3',
  };
  const smile = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Smile.png'),
      title: 'Smile',
      audioPrompt: 'appfiles/caring/option_smile.mp3',
  };
  const getGroceries = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Get groceries.png'),
      title: 'Get groceries',
      audioPrompt: 'appfiles/caring/option_get_groceries.mp3',
  };
  const newBag = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Get a new bag 2x.png'),
      title: 'Get a new bag',
      audioPrompt: 'appfiles/caring/option_get_a_new_bag.mp3',
  };
  const carry = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Help carry the bag copy.png'),
      title: 'Help carry the bag',
      audioPrompt: 'appfiles/caring/option_help_carry_the_bag.mp3',
  };
  let pickUpBox = {
      img: generateImageUrl('images/Module20Images/practiceIcon/pick up the box.png'),
      title: "Pick up box",
      audioPrompt: 'appfiles/caring/option_pick_up_the_box.mp3'
  }
  let standUpTheBox = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Stand up the box.png'),
      title: "Stand up the box",
      audioPrompt: 'appfiles/caring/option_stand_up_the_box.mp3'
  }
  let doubleCheck = {
      img: generateImageUrl('images/Module20Images/practiceIcon/check list.png'),
      title: "Double check the grocery list",
      audioPrompt: 'appfiles/caring/option_double_check_the_grocery_list.mp3'
  }
  let askForHaircut = {
      img: generateImageUrl('images/Module20Images/practiceIcon/ask for a haircut.png'),
      title: "Ask for haircut",
      audioPrompt: 'appfiles/caring/option_ask_for_a_haircut.mp3'
  }
  let pickUpComb = {
      img: generateImageUrl('images/Module20Images/practiceIcon/pick up the comb.png'),
      title: "Pick up the comb",
      audioPrompt: 'appfiles/caring/option_pick_up_the_comb.mp3'
  }
  let stopWater = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Stop the water.png'),
      title: "Stop the water",
      audioPrompt: 'appfiles/caring/option_stop_the_water.mp3'
  }
  let thankYou = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Say thank you.png'),
      title: `Say, "Thank you!"`,
      audioPrompt: 'appfiles/caring/option_say_thank_you.mp3'
  }
  let giveCombToStylist = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Give comb to hairstylist.png'),
      title: "Give the comb to stylist",
      audioPrompt: 'appfiles/caring/option_give_the_comb_to_the_hairstylist.mp3'
  }
  let mopTheFloo = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Mop the floor.png'),
      title: "Mop the floor",
      audioPrompt: 'appfiles/caring/option_mop_the_floor.mp3'
  }
  let pickUpClothes = {
      img: generateImageUrl('images/Module20Images/practiceIcon/pick up the clothes.png'),
      title: "Pick up the clothes",
      audioPrompt: 'appfiles/caring/option_pick_up_the_clothes.mp3'
  }
  let askForSocks = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Ask for socks.png'),
      title: "Ask for socks",
      audioPrompt: 'appfiles/caring/option_ask_for_socks.mp3'
  }
  let cheerUp = {
      img: generateImageUrl('images/Module20Images/practiceIcon/cheer them up.png'),
      title: "Cheer them up",
      audioPrompt: 'appfiles/caring/option_cheer_them_up.mp3'
  }
  let buySocks = {
      img: generateImageUrl('images/Module20Images/practiceIcon/buy the socks.png'),
      title: "Buy the socks",
      audioPrompt: 'appfiles/caring/option_buy_the_socks.mp3'
  }
  let foldClothes = {
      img: generateImageUrl('images/Module20Images/practiceIcon/fold the clothes.png'),
      title: "Fold the clothes",
      audioPrompt: 'appfiles/caring/option_fold_the_clothes.mp3'
  }
  let shareCandy = {
      img: generateImageUrl('images/Module20Images/practiceIcon/share candy.png'),
      title: "Share the candy",
      audioPrompt: 'appfiles/caring/option_share_candy.mp3'
  }
  let openDoor = {
      img: generateImageUrl('images/Module20Images/practiceIcon/open the  door.png'),
      title: "Open the door",
      audioPrompt: 'appfiles/caring/option_open_the_door.mp3'
  }
  let throwAwayCupcake = {
      img: generateImageUrl('images/Module20Images/practiceIcon/throw away cupcake.png'),
      title: "Throw away the cupcake",
      audioPrompt: 'appfiles/caring/option_throw_away.mp3'
  }
  let wipeFace = {
      img: generateImageUrl('images/Module20Images/practiceIcon/whipe your face.png'),
      title: "Wipe the face",
      audioPrompt: 'appfiles/caring/option_wipe_your_face.mp3'
  }
  let smileAtCrab = {
      img: generateImageUrl('images/Module20Images/practiceIcon/smile at the crab.png'),
      title: "Smile at the crab",
      audioPrompt: 'appfiles/caring/option_smile_at_the_crab.mp3'
  }
  let throwAwayNapkin = {
      img: generateImageUrl('images/Module20Images/practiceIcon/throw away napkin.png'),
      title: "Throw away the napkin",
      audioPrompt: 'appfiles/caring/option_throw_away.mp3'
  }
  let cleanMess = {
      img: generateImageUrl('images/Module20Images/practiceIcon/clean up the mess.png'),
      title: "Clean up the mess",
      audioPrompt: 'appfiles/caring/option_clean_up_the_mess.mp3'
  }
  let askForHelp = {
      img: generateImageUrl('images/Module20Images/practiceIcon/ask for help.png'),
      title: "Ask for help",
      audioPrompt: 'appfiles/caring/option_ask_for_help.mp3'
  }
  let sharePopcorn = {
      img: generateImageUrl('images/Module20Images/practiceIcon/share popcorn.png'),
      title: "Share the popcorn",
      audioPrompt: 'appfiles/caring/option_share_popcorn.mp3'
  }
  let recycleTheOtherBottles = {
      img: generateImageUrl('images/Module20Images/practiceIcon/recycle the other bottle.png'),
      title: "Recycle the other bottles",
      audioPrompt: 'appfiles/caring/option_recycle_the_other_bottles.mp3'
  }
  let shareMorePopcorn = {
      img: generateImageUrl('images/Module20Images/practiceIcon/share more popcorn.png'),
      title: "Share more popcorn",
      audioPrompt: 'appfiles/caring/option_share_more_popcorn.mp3'
  }

  useEffect(() => {
    switch (props.module.currentday) {
      case 1:
        setScene1({
          prompt:
            'What do you see you can do to take care of yourself? Touch the problem.',
          audioPrompt: 'appfiles/caring/practice_day_1_see_it.mp3',
          correctOptions: demoDaysBirdMessyHair,
          incorrectOptions: [recycleBin, dog],
          answerImagesStart: demoDaysBirdMessyHair,
          position: [
            { x: '25%', y: '60%' },
            { x: '10%', y: isIPad() ? '60%' : '55%' },
            { x: '70%', y: '50%' }
          ],
          size: [
            { h: '100%', w: '100%' },
            { h: '70%', w: '70%'},
            { h: '100%', w: '100%'},
          ],
        });
        setScene2({
          prompt: 'What can you fix to take care of yourself? Drag the item.',
          audioPrompt: 'appfiles/caring/practice_day_1_fix_it.mp3',
          correctOptions: combHair,
          incorrectOptions: [recycle, mop],
          position: [
                      { x: '25%', y: '58%' },
                      { x: '25%', y: '60%' },
                      { x: '10%', y: isIPad() ? '60%' : '55%' },
                      { x: '70%', y: '50%' }],
          answerImagesStart: demoDaysBirdMessyHair,
          answerImagesEnd: demoDaysBirdNormal,
          size: [
            { h: '100%', w: '100%' },
            { h: '70%', w: '70%'},
            { h: '100%', w: '100%'},
          ],
        });
        setScene3({
          prompt:
            'What can you do to make it even better for yourself? Drag the item.',
          audioPrompt: 'appfiles/caring/practice_day_1_make_it_better.mp3',
          correctOptions: smile,
          incorrectOptions: [getGroceries, mop],
          answerImagesStart: demoDaysBirdNormal,
          answerImagesEnd: demoDaysBirdHappy,
          position: [
            { x: '25%', y: '60%' },
            { x: '10%', y: isIPad() ? '60%' : '55%' },
            { x: '70%', y: '50%' }
          ],
          size: [
            { h: '100%', w: '100%' },
            { h: '70%', w: '70%'},
            { h: '100%', w: '100%'},
          ],
        });
        break;
      case 2:
        setScene1({
          prompt:
            'What do you see you can do to take care of others? Touch the problem.',
          audioPrompt: 'appfiles/caring/practice_day_2_see_it.mp3',
          correctOptions: demoDaysDogWithOranges,
          incorrectOptions: [recycleBin, demoDaysBirdNormal],
          answerImagesStart: demoDaysDogWithOranges,
          position: [ 
            { x: '60%', y: '50%' },
            { x: '10%', y: isIPad() ? '60%' : '55%' },
            { x: '25%', y: '60%' }
          ],
          size: [
            { h: '100%', w: '100%' },
            { h: '70%', w: '70%'},
            { h: '100%', w: '100%'},
          ],
        });
        setScene2({
          prompt: 'What can you fix to take care of others? Drag the item.',
          audioPrompt: 'appfiles/caring/practice_day_2_fix_it.mp3',
          correctOptions: newBag,
          incorrectOptions: [combHair, mop],
          position: [ { x: '63%', y: '60%'},
                      { x: '60%', y: '50%' },
                      { x: '10%', y: isIPad() ? '60%' : '55%' },
                      { x: '25%', y: '60%' }],
          answerImagesStart: demoDaysDogWithOranges,
          answerImagesEnd: demoDaysDog2GroceryBags,
          size: [
            { h: '100%', w: '100%' },
            { h: '70%', w: '70%'},
            { h: '100%', w: '100%'},
          ],
        });
        setScene3({
          prompt:
            'What can you do to make it even better for others? Drag the item.',
          audioPrompt: 'appfiles/caring/practice_day_2_make_it_better.mp3',
          correctOptions: carry,
          incorrectOptions: [getGroceries, mop],
          answerImagesStart: demoDaysDog2GroceryBags,
          answerImagesEnd: demoDaysDog1GroceryBag,
          answerImagesEnd2: bird1GroceryBag,
          position: [
            { x: '60%', y: '50%' },
            { x: '10%', y: isIPad() ? '60%' : '55%' },
            { x: '25%', y: '60%' }
          ],
          size: [
            { h: '100%', w: '100%' },
            { h: '70%', w: '70%' },
            { h: '100%', w: '100%' },
          ],
        });
        break;
      case 3:
        setScene1({
          prompt:
            'What do you see you can do to take care of world? Touch the problem.',
          audioPrompt: 'appfiles/caring/practice_day_3_see_it.mp3',
          correctOptions: demoDaysRecycleBinWithBottle,
          incorrectOptions: [dog, demoDaysBirdNormal],
          answerImagesStart: demoDaysRecycleBinWithBottle,
          position: [
            { x: '10%', y: isIPad() ? '60%' : '55%' },
            { x: '70%', y: '50%' },
            { x: '25%', y: '60%' }
          ],
          size: [
            { h: '100%', w: '100%' },
            { h: '100%', w: '100%'},
            { h: '100%', w: '100%'}
          ],
        });
        setScene2({
          prompt: 'What can you fix to take care of world? Drag the item.',
          audioPrompt: 'appfiles/caring/practice_day_3_fix_it.mp3',
          correctOptions: recycle,
          incorrectOptions: [combHair, newBag],
          position: [{ x: '15%', y: '55%' },
                    { x: '10%', y: isIPad() ? '60%' : '55%' },
                    { x: '70%', y: '50%' },
                    { x: '25%', y: '60%' }
          ],
          answerImagesStart: demoDaysRecycleBinWithBottle,
          answerImagesEnd: demoDaysWaterPuddle,
          size: [
            { h: '130%', w: '130%' },
            { h: '100%', w: '100%'},
            { h: '100%', w: '100%'},
          ],
        });
        setScene3({
          prompt:
            'What can you do to make it even better for others? Drag the item.',
          audioPrompt: 'appfiles/caring/practice_day_3_make_it_better.mp3',
          correctOptions: mop,
          incorrectOptions: [getGroceries, smile],
          answerImagesStart: demoDaysWaterPuddle,
          answerImagesEnd: demoDaysSparkleMopWater,
          position: [
            { x: '10%', y: isIPad() ? '60%' : '55%' },
            { x: '70%', y: '50%' },
            { x: '25%', y: '60%' }
          ],
          size: [
            { h: '130%', w: '130%' },
            { h: '100%', w: '100%'},
            { h: '100%', w: '100%'}
          ],
        });
        break;
      case 4:
        if (isIPhone()) {
          setGameInfo1({
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '50%', y: '75%', zoom:'80%' },
              { x: '5%', y: '80%', zoom:'70%' },
              { x: '30%', y: '60%', zoom:'60%' },
              { x: '75%', y: '63%', zoom:'80%' },
              { x: '69%', y: '45%', zoom:'100%' },
              { x: '-15%', y: '60%', zoom:'80%' },
            ],
          })
          setGameInfo2({
            options: [newBag, pickUpBox, getGroceries],
            position: [
              { x: '68%', y: '75%' },
              { x: '2%', y: '75%' },
              { x: '38%', y: '70%' },
            ],
            answer1ImagesEnd: [groceryStoreDog2Bags],
            answer2ImagesEnd: [groceryStoreDroppedBox],
            answer3ImagesEnd: [groceryStoreGroceriesInBasket],
            afterPosition: [
              { x: '50%', y: '75%' },
              { x: '1%', y: '25%' },
              { x: '30%', y: '60%' },
            ],
          })
          setGameInfo3({
            options: [carry, standUpTheBox, doubleCheck],
            position: [
              { x: '68%', y: '75%' },
              { x: '0%', y: '20%' },
              { x: '38%', y: '70%' },
            ],
            answer1ImagesEnd: [demoDaysDog1GroceryBag],
            answer2ImagesEnd: [groceryStoreBoxOnShelfStandUp],
            answer3ImagesEnd: [groceryStoreBirdWithListChecked],
            answer4ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            afterPosition: [
              { x: '50%', y: '75%' },
              { x: '2%', y: '16%' },
              { x: '30%', y: '60%' },
            ],
          })
        }
        else if (isIPad()) {
          setGameInfo1({
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '55%', y: '70%', zoom:'90%' },
              { x: '15%', y: '75%', zoom:'80%' },
              { x: '35%', y: '50%', zoom:'75%' },
              { x: '90%', y: '36%', zoom:'90%' },
              { x: '65%', y: '30%', zoom:'110%' },
              { x: '0%', y: '45%', zoom:'90%' },
            ],
          })
          setGameInfo2({
            options: [newBag, pickUpBox, getGroceries],
            position: [
              { x: '65%', y: '70%' },
              { x: '15%', y: '70%' },
              { x: '42%', y: '65%' },
            ],
            answer1ImagesEnd: [groceryStoreDog2Bags],
            answer2ImagesEnd: [groceryStoreDroppedBox],
            answer3ImagesEnd: [groceryStoreGroceriesInBasket],
            afterPosition: [
              { x: '55%', y: '70%' },
              { x: '8%', y: '35%' },
              { x: '35%', y: '50%' },
            ],
          })
          setGameInfo3({
            options: [carry, standUpTheBox, doubleCheck],
            position: [
              { x: '65%', y: '70%' },
              { x: '8%', y: '35%' },
              { x: '42%', y: '65%' },
            ],
            answer1ImagesEnd: [demoDaysDog1GroceryBag],
            answer2ImagesEnd: [groceryStoreBoxOnShelfStandUp],
            answer3ImagesEnd: [groceryStoreBirdWithListChecked],
            answer4ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            afterPosition: [
              { x: '55%', y: '70%' },
              { x: '8%', y: '25%' },
              { x: '35%', y: '50%' },
            ],
          })
        }
        else {
          setGameInfo1({
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '62%', y: '65%', zoom:'100%' },
              { x: '25%', y: '80%', zoom:'100%' },
              { x: '40%', y: '35%', zoom:'100%' },
              { x: '90%', y: '59%', zoom:'100%' },
              { x: '69%', y: '49%', zoom:'100%' },
              { x: '0.5%', y: '65%', zoom:'100%' },
            ],
          })
          setGameInfo2({
            options: [newBag, pickUpBox, getGroceries],
            position: [
              { x: '70%', y: '72%' },
              { x: '25%', y: '75%' },
              { x: '48%', y: '70%' },
            ],
            answer1ImagesEnd: [groceryStoreDog2Bags],
            answer2ImagesEnd: [groceryStoreDroppedBox],
            answer3ImagesEnd: [groceryStoreGroceriesInBasket],
            afterPosition: [
              { x: '62%', y: '65%' },
              { x: '9%', y: '50%' },
              { x: '40%', y: '35%' },
            ],
          })
          setGameInfo3({
            options: [carry, standUpTheBox, doubleCheck],
            position: [
              { x: '70%', y: '72%' },
              { x: '9%', y: '46%' },
              { x: '48%', y: '70%' },
            ],
            answer1ImagesEnd: [demoDaysDog1GroceryBag],
            answer2ImagesEnd: [groceryStoreBoxOnShelfStandUp],
            answer3ImagesEnd: [groceryStoreBirdWithListChecked],
            answer4ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            afterPosition: [
              { x: '62%', y: '65%' },
              { x: '10%', y: '40%' },
              { x: '40%', y: '35%' },
            ],
          })
        }
        setPractice(true)
        break;
      case 5:
        if (isIPhone()) {
          setGameInfo1({
            correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
            incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonMirror],
            position: [
              { x: '5%', y: '75%', zoom:'80%' },
              { x: '35%', y: '90%', zoom:'40%' },
              { x: '0%', y: '5%', zoom:'90%' },
              { x: '-5%', y: '53%', zoom:'100%' },
              { x: '65%', y: '40%', zoom:'100%' },
              { x: '6%', y: '45%', zoom:'120%' },
            ],
          })
          setGameInfo2({
            options: [askForHaircut, pickUpComb, stopWater],
            position: [
              { x: '0%', y: '75%' },
              { x: '30%', y: '85%' },
              { x: '20%', y: '30%' },
            ],
            answer1ImagesEnd: [hairSalonBird],
            answer2ImagesEnd: [hairSalonComb],
            answer3ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4_M5_Puddle.svg')],
            afterPosition: [
              { x: '5%', y: '77%' },
              { x: '15%', y: '85%' },
              { x: '30%', y: '150%' },
            ],
          })
          setGameInfo3({
            options: [thankYou, giveCombToStylist, mopTheFloo],
            position: [
              { x: '7%', y: '70%' },
              { x: '60%', y: '80%' },
              { x: '30%', y: '130%' },
            ],
            answer1ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            answer2ImagesEnd: [generateImageUrl('images/Module20Images/practice/Hairstylist_Happy.svg')],
            answer3ImagesEnd: [null],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '15%', y: '62%' },
              { x: '55%', y: '77%', zoom:'95%' },
              { x: '30%', y: '45%' },
            ],
          })
        }
        else if (isIPad()) {
          setGameInfo1({
            correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
            incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
            position: [
              { x: '10%', y: '65%', zoom:'90%' },
              { x: '37%', y: '85%', zoom:'50%' },
              { x: '5%', y: '10%', zoom:'85%' },
              { x: '10%', y: '0%', zoom:'115%' },
              { x: '0%', y: '0%', zoom:'130%' },
              { x: '20%', y: '0%', zoom:'145%' },
            ],
          })
          setGameInfo2({
            options: [askForHaircut, pickUpComb, stopWater],
            position: [
              { x: '10%', y: '68%' },
              { x: '35%', y: '80%' },
              { x: '25%', y: '25%' },
            ],
            answer1ImagesEnd: [hairSalonBird],
            answer2ImagesEnd: [hairSalonComb],
            answer3ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4_M5_Puddle.svg')],
            afterPosition: [
              { x: '10%', y: '65%' },
              { x: '20%', y: '75%' },
              { x: '35%', y: '150%' },
            ],
          })
          setGameInfo3({
            options: [thankYou, giveCombToStylist, mopTheFloo],
            position: [
              { x: '10%', y: '65%' },
              { x: '58%', y: '75%' },
              { x: '35%', y: '130%' },
            ],
            answer1ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            answer2ImagesEnd: [generateImageUrl('images/Module20Images/practice/Hairstylist_Happy.svg')],
            answer3ImagesEnd: [null],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '70%', y: '65%' },
              { x: '56%', y: '75%', zoom:'115%' },
              { x: '35%', y: '40%' },
            ],
          })
        }
        else {
          setGameInfo1({
            correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
            incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
            position: [
              { x: '15%', y: '58%', zoom:'100%' },
              { x: '40%', y: '80%', zoom:'50%' },
              { x: '0%', y: '5%', zoom:'90%' },
              { x: '20%', y: '0%', zoom:'100%' },
              { x: '10%', y: '0%', zoom:'100%' },
              { x: '30%', y: '0%', zoom:'90%' },
            ],
          })
          setGameInfo2({
            options: [askForHaircut, pickUpComb, stopWater],
            position: [
              { x: '15%', y: '60%' },
              { x: '37%', y: '75%' },
              { x: '20%', y: '30%' },
            ],
            answer1ImagesEnd: [hairSalonBird],
            answer2ImagesEnd: [hairSalonComb],
            answer3ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4_M5_Puddle.svg')],
            afterPosition: [
              { x: '15%', y: '58%' },
              { x: '15%', y: '70%' },
              { x: '30%', y: '160%' },
            ],
          })
          setGameInfo3({
            options: [thankYou, giveCombToStylist, mopTheFloo],
            position: [
              { x: '15%', y: '60%' },
              { x: '60%', y: '70%' },
              { x: '30%', y: '140%' },
            ],
            answer1ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            answer2ImagesEnd: [generateImageUrl('images/Module20Images/practice/Hairstylist_Happy.svg')],
            answer3ImagesEnd: [null],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '65%', y: '50%' },
              { x: '58%', y: '60%', zoom:'120%' },
              { x: '30%', y: '45%' },
            ],
          })
        }
        setPractice(true)
        break;
      case 6:
        if (isIPhone()) {
          setGameInfo1({
            correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
            incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
            position: [
              { x: '65%', y: '78%', zoom:'60%' },
              { x: '2%', y: '85%', zoom:'60%' },
              { x: '100%', y: '80%', zoom:'100%' },
              { x: '50%', y: '40%', zoom:'90%'},
              { x: '7%', y: '72%', zoom:'90%'},
              { x: '65%', y: '60%', zoom:'70%'},
            ],
          })
          setGameInfo2({
            options: [askForSocks, cheerUp, pickUpClothes],
            position: [
              { x: '65%', y: '60%' },
              { x: '13%', y: '85%' },
              { x: '105%', y: '70%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
            answer1ImagesEnd: [clothingStoreSocks],
            answer2ImagesEnd: [clothingStoreLizardHappy],
            afterPosition: [
              { x: '65%', y: '78%' },
              { x: '2%', y: '85%' },
              { x: '50%', y: '15%' },

            ],
          })
          setGameInfo3({
            options: [buySocks, shareCandy, foldClothes],
            position: [
              { x: '65%', y: '60%' },
              { x: '13%', y: '85%' },
              { x: '50%', y: '5%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
            answer1ImagesEnd: [bigBirdHappy],
            answer2ImagesEnd: [lizardCandy],
            afterPosition: [
              { x: '65%', y: '78%', zoom:'100%' },
              { x: '2%', y: '85%', zoom:'60%' },
              { x: '50%', y: '10%', zoom:'100%' },
            ],
          })
        }
        else if (isIPad()) {
          setGameInfo1({
            correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
            incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
            position: [
              { x: '70%', y: '70%', zoom:'80%' },
              { x: '8%', y: '70%', zoom:'100%' },
              { x: '100%', y: '75%', zoom:'100%' },
              { x: '53%', y: '42%', zoom:'90%'},
              { x: '11%', y: '73%', zoom:'90%'},
              { x: '60%', y: '45%', zoom:'90%'},
            ],
          })
          setGameInfo2({
            options: [askForSocks, cheerUp, pickUpClothes],
            position: [
              { x: '65%', y: '55%' },
              { x: '18%', y: '75%' },
              { x: '100%', y: '65%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
            answer1ImagesEnd: [clothingStoreSocks],
            answer2ImagesEnd: [clothingStoreLizardHappy],
            afterPosition: [
              { x: '70%', y: '70%' },
              { x: '8%', y: '70%' },
              { x: '50%', y: '12%' },
            ],
          })
          setGameInfo3({
            options: [buySocks, shareCandy, foldClothes],
            position: [
              { x: '75%', y: '55%' },
              { x: '18%', y: '75%' },
              { x: '55%', y: '10%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
            answer1ImagesEnd: [bigBirdHappy],
            answer2ImagesEnd: [lizardCandy],
            afterPosition: [
              { x: '70%', y: '70%' },
              { x: '8%', y: '70%' },
              { x: '51%', y: '10%' },
            ],
          })
        }
        else {
          if (window.innerHeight > 1000) {
            setGameInfo1({
              correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
              incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
              position: [
                { x: '75%', y: '50%', zoom:'100%' },
                { x: '2%', y: '70%', zoom:'100%' },
                { x: '100%', y: '80%', zoom:'100%' },
                { x: '50%', y: '40%', zoom:'120%'},
                { x: '7%', y: '72%', zoom:'120%'},
                { x: '53%', y: '30%', zoom:'100%' },
              ],
            })
            setGameInfo2({
              options: [askForSocks, cheerUp, pickUpClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '105%', y: '70%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
              answer1ImagesEnd: [clothingStoreSocks],
              answer2ImagesEnd: [clothingStoreLizardHappy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '15%' },

              ],
            })
            setGameInfo3({
              options: [buySocks, shareCandy, foldClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '55%', y: '10%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
              answer1ImagesEnd: [bigBirdHappy],
              answer2ImagesEnd: [lizardCandy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '10%' },
              ],
                        })
          }
          else {
            setGameInfo1({
              correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
              incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
              position: [
                { x: '75%', y: '50%', zoom:'100%' },
                { x: '2%', y: '70%', zoom:'100%' },
                { x: '100%', y: '80%', zoom:'100%' },
                { x: '50%', y: '40%', zoom:'90%'},
                { x: '7%', y: '72%', zoom:'90%'},
                { x: '53%', y: '30%', zoom:'100%'},
              ],
            })
            setGameInfo2({
              options: [askForSocks, cheerUp, pickUpClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '105%', y: '70%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
              answer1ImagesEnd: [clothingStoreSocks],
              answer2ImagesEnd: [clothingStoreLizardHappy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '15%' },

              ],
            })
            setGameInfo3({
              options: [buySocks, shareCandy, foldClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '55%', y: '10%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
              answer1ImagesEnd: [bigBirdHappy],
              answer2ImagesEnd: [lizardCandy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '10%' },
              ],
            })
          }
        }
        setPractice(true)
        break;
      case 7:
        if (isIPhone()) {
          setGameInfo1({
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '0%', y: '70%', zoom: "55%"},
              { x: '40%', y: '60%', zoom: "55%"},
              { x: '70%', y: '70%', zoom: "55%"},
              { x: '23%', y: '40%', zoom: "80%"},
              { x: '30%', y: '56%', zoom: "100%"},
              { x: '65%', y: '50%', zoom: '80%' },
            ],
          })
          setGameInfo2({
            options: [openDoor, wipeFace, throwAwayCupcake],
            position: [
              { x: '5%', y: '70%' },
              { x: '40%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabBoxesWorried],
            answer2ImagesEnd: [bakeryNapkinWithBird],
            answer3ImagesEnd: [bakeryTrashCanMess],
            afterPosition: [
              { x: '0%', y: '70%' },
              { x: '40%', y: '60%' },
              { x: '70%', y: '70%' },
            ],
          })
          setGameInfo3({
            options: [smileAtCrab, throwAwayNapkin, cleanMess],
            position: [
              { x: '5%', y: '70%' },
              { x: '40%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabSmiling],
            answer2ImagesEnd: [bigBirdHappy],
            answer3ImagesEnd: [bakerySparkle],
            afterPosition: [
              { x: '0%', y: '70%' },
              { x: '40%', y: '60%', zoom: "60%"},
              { x: '70%', y: '70%' },
            ],
          })
        }
        else if (isIPad()) {
          setGameInfo1({
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '0%', y: '60%'},
              { x: '42%', y: '50%'},
              { x: '70%', y: '60%'},
              { x: '30%', y: '28%'},
              { x: '28%', y: '54%'},
              { x: '65%', y: '48%', zoom:'85%' },
            ],
          })
          setGameInfo2({
            options: [openDoor, wipeFace, throwAwayCupcake],
            position: [
              { x: '20%', y: '65%' },
              { x: '50%', y: '55%' },
              { x: '80%', y: '65%' },
            ],
            answer1ImagesEnd: [bakeryCrabBoxesWorried],
            answer2ImagesEnd: [bakeryNapkinWithBird],
            answer3ImagesEnd: [bakeryTrashCanMess],
            afterPosition: [
              { x: '0%', y: '60%' },
              { x: '42%', y: '50%' },
              { x: '70%', y: '60%' },
            ],
          })
          setGameInfo3({
            options: [smileAtCrab, throwAwayNapkin, cleanMess],
            position: [
              { x: '20%', y: '65%' },
              { x: '50%', y: '55%' },
              { x: '80%', y: '65%' },
            ],
            answer1ImagesEnd: [bakeryCrabSmiling],
            answer2ImagesEnd: [bigBirdHappy],
            answer3ImagesEnd: [bakerySparkle],
            afterPosition: [
              { x: '0%', y: '60%' },
              { x: '42%', y: '50%'},
              { x: '70%', y: '60%' },
            ],
          })
        }
        else{
          setGameInfo1({
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '15%', y: '45%'},
              { x: '45%', y: '45%'},
              { x: '70%', y: '50%'},
              { x: '16%', y: '35%'},
              { x: '28%', y: '56%'},
              { x: '65%', y: '50%', zoom:'80%' },
            ],
          })
          setGameInfo2({
            options: [openDoor, wipeFace, throwAwayCupcake],
            position: [
              { x: '25%', y: '70%' },
              { x: '50%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabBoxesWorried],
            answer2ImagesEnd: [bakeryNapkinWithBird],
            answer3ImagesEnd: [bakeryTrashCanMess],
            afterPosition: [
              { x: '15%', y: '45%' },
              { x: '45%', y: '45%' },
              { x: '70%', y: '50%' },
            ],
          })
          setGameInfo3({
            options: [smileAtCrab, throwAwayNapkin, cleanMess],
            position: [
              { x: '25%', y: '70%' },
              { x: '50%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabSmiling],
            answer2ImagesEnd: [bigBirdHappy],
            answer3ImagesEnd: [bakerySparkle],
            afterPosition: [
              { x: '15%', y: '45%' },
              { x: '45%', y: '45%'},
              { x: '70%', y: '50%' },
            ],
          })
        }
        setPractice(true)
        break;
      case 8:
        if (isIPhone()) {
          setGameInfo1({
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '60%', zoom:'60%'},
              { x: '56%', y: '45%'},
              { x: '9%', y: '35%'},
              { x: '60%', y: '70%'},
            ],
          })
          setGameInfo2({
            options: [askForHelp, sharePopcorn, recycle],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabPointing],
            answer2ImagesEnd: [movieMonkey],
            answer3ImagesEnd: [movie2WaterBottles],
            afterPosition: [
              { x: '57.5%', y: '67.5%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
          setGameInfo3({
            options: [thankYou, shareMorePopcorn, recycleTheOtherBottles],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabThoughtHeart],
            answer2ImagesEnd: [movieMonkeyHappy],
            answer3ImagesEnd: [movieRecycleBinSparkle],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '60%', y: '70%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
        }
        else if (isIPad()) {
          setGameInfo1({
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '50%', zoom:'60%'},
              { x: '65%', y: '53%', zoom:'130%'},
              { x: '-3%', y: '27%'},
              { x: '60%', y: '70%'},
            ],
          })
          setGameInfo2({
            options: [askForHelp, sharePopcorn, recycle],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '50%' },
            ],
            answer1ImagesEnd: [movieCrabPointing],
            answer2ImagesEnd: [movieMonkey],
            answer3ImagesEnd: [movie2WaterBottles],
            afterPosition: [
              { x: '57.5%', y: '67.5%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '50%' }
            ],
          })
          setGameInfo3({
            options: [thankYou, shareMorePopcorn, recycleTheOtherBottles],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '50%' },
            ],
            answer1ImagesEnd: [movieCrabThoughtHeart],
            answer2ImagesEnd: [movieMonkeyHappy],
            answer3ImagesEnd: [movieRecycleBinSparkle],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '60%', y: '70%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '50%' }
            ],
          })
        }
        else{ 
          setGameInfo1({
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '60%', zoom:'60%'},
              { x: '56%', y: '45%'},
              { x: '9%', y: '35%'},
              { x: '60%', y: '70%'},
            ],
          })
          setGameInfo2({
            options: [askForHelp, sharePopcorn, recycle],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabPointing],
            answer2ImagesEnd: [movieMonkey],
            answer3ImagesEnd: [movie2WaterBottles],
            afterPosition: [
              { x: '57.5%', y: '67.5%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
          setGameInfo3({
            options: [thankYou, shareMorePopcorn, recycleTheOtherBottles],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabThoughtHeart],
            answer2ImagesEnd: [movieMonkeyHappy],
            answer3ImagesEnd: [movieRecycleBinSparkle],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '60%', y: '70%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
        }
        setPractice(true)
        break;
      default:
        break;
    }
  }, []);

  // let scene2 = {
  //     correctOptions: dogOranges,
  //     incorrectOptions: [bird, recycleBin],
  //     prompt: "What do you see you can do to take care of world? Touch the problem",
  //     audioPrompt: AndreaAudio.caringPracticeDay2SeeIt.rawValue}

  // let scene3 = {correctOptions: recycleBineWithBottlePuddle,
  //     incorrectOptions: [bird, dog],
  //     prompt: "What do you see you can do to take care of the world? Touch the problem",
  //     audioPrompt: AndreaAudio.caringPracticeDay3SeeIt.rawValue}

  const titles = [
    'Step 1: See it',
    'Step 2: Fix it',
    'Step 3: Make it even better',
  ];

  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );
  const displayPractice = async (num) => {
    setIntroSound('');
    setQuestion(false);
    if (num === 1) {
      setCorrectImgX(scene1.position[0].x);
      setCorrectImgY(scene1.position[0].y);
      setWrongImg1X(scene1.position[1].x);
      setWrongImg1Y(scene1.position[1].y);
      setWrongImg2X(scene1.position[2].x);
      setWrongImg2Y(scene1.position[2].y);
      setCorrectImgH(scene1.size[0].h);
      setCorrectImgW(scene1.size[0].w);
      setWrongImg1H(scene1.size[1].h);
      setWrongImg1W(scene1.size[1].w);
      setWrongImg2H(scene1.size[2].h);
      setWrongImg2W(scene1.size[2].w);
      setSeletedImgX(scene2.position[0].x);
      setSeletedImgY(scene2.position[0].y);
      setTtitle('Step 1: See it');
      setChangeText(scene1.prompt);
      setIntroSound(getVideo(scene1.audioPrompt, login));
      setCorrectImg(scene1.answerImagesStart);
      setWrongImg1(scene1.incorrectOptions[0]);
      setWrongImg2(scene1.incorrectOptions[1]);
      setQuestion(true);
      setOpenPractice(true);
      setEffect1('');
      setEffect2('bounceIcons');
      setApple2(true);
    } else if (num === 2) {
      let numArray = [];
      setTargetKey(scene2.correctOptions.title);
      numArray = [
        scene2.correctOptions,
        scene2.incorrectOptions[0],
        scene2.incorrectOptions[1],
      ];
      numArray = numArray
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      setMatchOptions(numArray);
      setEndImg(scene2.answerImagesEnd);
      setAnimationEffect('');
      setSeletedImg(
        generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg')
      );
      setTtitle('Step 2: Fix it');
      setChangeText(scene2.prompt);
      setIntroSound(getVideo(scene2.audioPrompt, login));
      setQuestion(true);
      setOpenPractice(true);
      setEffect2('');
      setEffect3('bounceIcons');
      setApple3(true);
    } else if (num === 3) {
      let numArray = [];
      setTargetKey(scene3.correctOptions.title);
      numArray = [
        scene3.correctOptions,
        scene3.incorrectOptions[0],
        scene3.incorrectOptions[1],
      ];
      numArray = numArray
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      setMatchOptions(numArray);
      setEndImg(scene3.answerImagesEnd);
      setSeletedImg(
        generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg')
      );
      setTtitle('Step 3: Make it even better');
      setChangeText(scene3.prompt);
      setIntroSound(getVideo(scene3.audioPrompt, login));
      setQuestion(true);
      setOpenPractice(true);
      setDisplayReview(true);
      setAppleScene(false);
    }
    setOpenPractice(true);
  };

  const onHit = (e) => {
    const audio = new Audio(transitionSound);
    audio.play();
    setSeletedImg(null);
    setCorrectImg(endImg);
    if (apple3 && !displayReview ) {
      setCorrectImgX(scene2.position[1].x);
      setCorrectImgY(scene2.position[1].y);
      setWrongImg1X(scene2.position[2].x);
      setWrongImg1Y(scene2.position[2].y);
      setWrongImg2X(scene2.position[3].x);
      setWrongImg2Y(scene2.position[3].y);
      setCorrectImgH(scene2.size[0].h);
      setCorrectImgW(scene2.size[0].w);
      setWrongImg1H(scene2.size[1].h);
      setWrongImg1W(scene2.size[1].w);
      setWrongImg2H(scene2.size[2].h);
      setWrongImg2W(scene2.size[2].w);
    }
    else if (apple3 && displayReview ) {
      setCorrectImgX(scene3.position[0].x);
      setCorrectImgY(scene3.position[0].y);
      setWrongImg1X(scene3.position[1].x);
      setWrongImg1Y(scene3.position[1].y);
      setWrongImg2X(scene3.position[2].x);
      setWrongImg2Y(scene3.position[2].y);
      setCorrectImgH(scene3.size[0].h);
      setCorrectImgW(scene3.size[0].w);
      setWrongImg1H(scene3.size[1].h);
      setWrongImg1W(scene3.size[1].w);
      setWrongImg2H(scene3.size[2].h);
      setWrongImg2W(scene3.size[2].w);
      if(props.module.currentday === 2){
        setWrongImg2(scene3.answerImagesEnd2)
      }
    }
    sleep(2000).then(() => {
      setOpenPractice(false);
      if(!displayReview){
        sleep(700).then(() => {
          bounceSound.play()
        });
      }
    });
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function onDrag(option) {
    setAnimalVoice('');
    setAnimaTalk(false);
    setQuestion(false);
    setAnimalVoice(getVideo(option.audioPrompt, login));
    setAnimaTalk(true);
  }

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      {openPractice && (
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceSituationHeader'>{title}</h2>
          <h3 className='practiceSituationQuestion'>{changeText}</h3>
          <br />
          <img
            className='bakeryStore'
            src={BakeryStoreGreen}
          ></img>
          {seletedImg && (
            <div
              className='seletedImage'
              style={{ top: seletedImgY, left: seletedImgX }}
            >
              <DropTarget
                targetKey={targetKey}
                onHit={(e) => {
                  onHit(e);
                }}
                style={{ height: '150px', width: '150px' }}
              >
                <img alt='' className='selectedBox' src={seletedImg} />
              </DropTarget>
            </div>
          )}
          <div
            className='gameElement'
            id={animationEffect}
            style={{ top: correctImgY, left: correctImgX}}
            onClick={() => {
              if(!seletedImg){
                const audio = new Audio(
                  generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                );
                audio.play();
                document.getElementsByClassName(
                  'gameElement'
                )[0].style.animationDuration = '0s';
                document.getElementsByClassName(
                  'gameElement'
                )[0].style.animationDuration = '0s';
                setIntroSound('');
                setQuestion(false);
                sleep(2000).then(() => {
                  setOpenPractice(false);
                  if(!displayReview){
                    sleep(700).then(() => {
                      bounceSound.play()
                    });
                  }
                });
              }
            }}
          >
            <div className='imgElement' style={{height: correctImgH, width: correctImgW }}>
              <img alt='' src={correctImg} />
            </div>
          </div>
          <div
            className='gameElement'
            id={animationEffect}
            style={{ top: wrongImg1Y, left: wrongImg1X}}
            onClick={() => {
              if(!seletedImg){
                setAnimalVoice('');
                setAnimaTalk(false);
                setAnimalVoice(getVideo( `appfiles/eye_contact/andrea_try_again.mp3`, login));
                setAnimaTalk(true);
                document.getElementsByClassName('gameElement')[1].style.pointerEvents = 'none';
                document.getElementsByClassName('gameElement')[1].style.animationDuration = '0s';
              }
            }}
          >
            <div className='imgElement' style={{height: wrongImg1H, width: wrongImg1W}}>
              <img alt='' src={wrongImg1} />
            </div>
          </div>
          <div
            className='gameElement'
            id={animationEffect}
            style={{ top: wrongImg2Y, left: wrongImg2X}}
            onClick={() => {
              if(!seletedImg){
                setAnimalVoice('');
                setAnimaTalk(false);
                setAnimalVoice(getVideo(`appfiles/eye_contact/andrea_try_again.mp3`, login));
                setAnimaTalk(true);
                document.getElementsByClassName('gameElement')[2].style.pointerEvents = 'none';
                document.getElementsByClassName('gameElement')[2].style.animationDuration = '0s';     
              }      
          }}
          >
            <div className='imgElement' style={{height: wrongImg2H, width: wrongImg2W}}>
              <img alt='' src={wrongImg2} />
            </div>
          </div>
          {seletedImg && (
            <div className='practice20Grid'>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[0], id: 0 }}
                  targetKey={matchOptions[0].title}
                  onDragStart={() => onDrag(matchOptions[0])}
                >
                  {matchOptions[0] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[0].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[1], id: 1 }}
                  targetKey={matchOptions[1].title}
                  onDragStart={() => onDrag(matchOptions[1])}
                >
                  {matchOptions[1] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[1].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[2], id: 2 }}
                  targetKey={matchOptions[2].title}
                  onDragStart={() => onDrag(matchOptions[2])}
                >
                  {matchOptions[2] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[2].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
            </div>
          )}
        </div>
      )}
      {!animalTalk && question && (
        <audio autoPlay onEnded={() => setQuestion(false)}>
          <source src={introSound}></source>
        </audio>
      )}
      {animalTalk && (
        <audio
          autoPlay
          onEnded={() => {
            setAnimaTalk(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {appleScene && !openPractice && (
        <div
          className='appleScene'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          {displayLearnVideo && (
            <CloudfrontVideoFormat
              source={learnVideo}
              back={'unit4'}
              background={props.background}
              close={props.setDisplayPractice}
              ended={() => {
                setDisplayLearnVideo(false);
                setApples(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              }}
            />
          )}
          {apples && (
            <div className='bird_apple'>
              {apple1 && (
                <div
                  className='apple1'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayPractice(1);
                    });
                  }}
                >
                  <img alt='' className='apple1' id={effect1} src={apple1Img} />
                </div>
              )}
              {apple2 && (
                <div
                  className='apple2'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayPractice(2);
                    });
                  }}
                >
                  <img alt='' className='apple2' id={effect2} src={apple2Img} />
                </div>
              )}
              {apple3 && (
                <div
                  className='apple3'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayPractice(3);
                    });
                  }}
                >
                  <img alt='' className='apple3' id={effect3} src={apple3Img} />
                </div>
              )}
              {/* {<img alt='' className='bird10' src={props.animal} />} */}
              {(props.module.currentday <= 3) && <img className='appleTree' src={Tree} ></img>}
            </div>
          )}
        </div>
      )}
      {!openPractice && displayReview && (
        <Practice
          reviewVideo={props.video2}
          setDisplayPractice={props.setDisplayPractice}
          background={props.background}
          stepComplete={'MODULE20_SET_stepCompleted'}
          module={props.module}
          unit4={true}
          conversationGIF={props.conversationGIF}
          conversationAudio={props.conversationAudio}
          endAudio={props.endAudio}
          endGIF={props.endGIF}
          name={`caring_practice_video_${props.module.currentday}.mp4`}
        />
      )}
      {practice && (
        <PracticeSituation
          day4={props.module.currentday === 4 ? true : false}
          day5={props.module.currentday === 5 ? true : false}
          day6={props.module.currentday === 6 ? true : false}
          day7={props.module.currentday === 7 ? true : false}
          day8={props.module.currentday === 8 ? true : false}
          gameInfo1={gameInfo1}
          gameInfo2={gameInfo2}
          gameInfo3={gameInfo3}
          setDisplayPractice={props.setDisplayPractice}
          background={props.background}
          background1={props.background1}
          stepComplete={'MODULE20_SET_stepCompleted'}
          module={props.module}
          conversationGIF={props.conversationGIF}
          conversationAudio={props.conversationAudio}
          endAudio={props.endAudio}
          endGIF={props.endGIF}
          instructions={props.instructions}
          names={props.names}
          texts={props.texts}
          voices={props.voices}
          influencerid={props.influencerid}
          introductionMP3={
            'appfiles/caring/caring_practice_conversation.mp3'
          }
          introduction={props.introduction}
          practiceMessage={props.practiceMessage}
          practiceConversation={props.practiceConversation}
          awesomeJob={props.awesomeJob}
          exampleVideo = {props.exampleVideo}
        />
      )}
    </>
  );
}
